import script from "./updateEmailForm.vue?vue&type=script&setup=true&lang=js"
export * from "./updateEmailForm.vue?vue&type=script&setup=true&lang=js"

import "./updateEmailForm.vue?vue&type=style&index=0&id=534b4acb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-534b4acb"]])

export default __exports__